import React from "react";
import "./About.scss";

const AboutUs = () => {
  return (
    <div className="about-us-container">
      <h1>About Us</h1>
      <p>
        Founded in 2024 by Dhananjay and Aryan Yadav, NeoSapien is an
        India-based company at the forefront of wearable technology innovation.
        We design devices that integrate seamlessly into daily lives.
      </p>
      <p>
        Our flagship product, the Neo 1, serves as a smart, non-intrusive
        companion designed to capture and process conversations in real time.
        Neo is your silent, ever-present partner—listening attentively, taking
        detailed notes, and analyzing your conversations.
      </p>
      <p>
        It doesn’t stop there: Neo becomes a brainstorming ally, offering
        suggestions and insights that help you innovate, connect, and thrive,
        both professionally and personally.
      </p>
      <p>
        At NeoSapien, we are driven by a passion for integrating AI into daily
        routines in ways that are natural and intuitive. Our mission is to
        create wearable technology that goes beyond functionality—augmenting
        cognitive abilities and helping users manage the challenges of modern
        living with ease.
      </p>
      <p>
        We place a strong emphasis on R&D in artificial intelligence, driving
        advancements that pave the way for truly personalized AI experiences.
        Our vision is to create AI solutions that adapt to each individual,
        delivering unique insights and assistance tailored to their needs.
      </p>
      <p>
        Equally, we are committed to a relentless focus on privacy, ensuring
        that our technology empowers users while safeguarding their personal
        data. By combining cutting-edge innovation with an unwavering dedication
        to user trust, NeoSapien is redefining the relationship between humans
        and technology.
      </p>
      <p>
        Through innovation and a persistent focus on user needs, we’re
        reimagining the possibilities of wearable tech, forging a new
        relationship between humans and technology.
      </p>
      <p>Legal Entity Name : ZENITHZEPHYR WELLNESS PRIVATE LIMITED</p>

      <h4>Business Address</h4>
      <address>
        ScalerInnovation Lab,
        <br />
        Scaler School of Technology,
        <br />
        Parappana Agrahar, Electronic City Road,
        <br />
        Phase 1, Bengaluru, Karnataka - 560100
      </address>
    </div>
  );
};

export default AboutUs;
